import Swiper from 'swiper';

// Our History
var timelineSwiper = new Swiper('.our-history .swiper-container', {
    direction: 'vertical',
    loop: false,
    speed: 1600,
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
        renderBullet: function (index, className) {
            var year = document.querySelectorAll('.swiper-slide')[index].getAttribute('data-year')
            return '<span class="' + className + '">' + year + '</span>'
        }
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
});
// Basic slideshow
var basic_slideshow = new Swiper('.basic-swiper', {
    direction: 'horizontal',
    a11y: true,
    loop: true,
    autoplay: {
      delay: 10000,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },
});